import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBolt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9 15L14 7V11H19L14 19V15H9Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.1875 6.23214L6.5 4L6.8125 6.1875L9 6.5L6.8125 6.8125L6.5 9L6.1875 6.8125L4 6.5L6.1875 6.23214Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	})]
});
export default SvgBolt;
